// Contact form, newsletter sign-up, and the admin's Messages / Subscribers data.
import { supabase } from './supabaseClient';

var FUNCTIONS_URL = (process.env.REACT_APP_SUPABASE_URL || '') + '/functions/v1/';
var NOT_CONNECTED = 'Not connected to the database. Please try again later.';
var LOAD_FAILED = 'Could not load this. Check your internet connection and refresh the page.';
var SAVE_FAILED = 'Could not save. Please check your internet connection and try again.';

async function postFunction(name, payload, fallback) {
  if (!process.env.REACT_APP_SUPABASE_URL) return { error: NOT_CONNECTED };
  try {
    var res = await fetch(FUNCTIONS_URL + name, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    var data = await res.json().catch(function() { return {}; });
    if (res.ok && data && data.ok) return { error: null };
    return { error: (data && data.error) || fallback };
  } catch (e) {
    return { error: "Couldn't reach the shop. Please check your internet connection and try again." };
  }
}

// form: { name, email, category, order_number, message }
export function sendContactMessage(form) {
  return postFunction('submit-contact', {
    name: form.name,
    email: form.email,
    category: form.category,
    orderNumber: form.order_number,
    message: form.message
  }, "Your message wasn't sent. Please try again.");
}

export function subscribeToNewsletter(email) {
  return postFunction('subscribe', { email: email }, "Couldn't sign you up. Please try again.");
}

// ---- Admin ----

export async function fetchContactMessages() {
  if (!supabase) return { messages: [], error: NOT_CONNECTED };
  var r = await supabase.from('contact_messages').select('*').order('created_at', { ascending: false });
  if (r.error) {
    console.error('Could not load messages:', r.error.message);
    return { messages: [], error: LOAD_FAILED };
  }
  return { messages: r.data || [], error: null };
}

export async function setMessageRead(id, read) {
  if (!supabase) return { error: NOT_CONNECTED };
  var r = await supabase.from('contact_messages').update({ read: read }).eq('id', id).select('id');
  if (r.error || !r.data || r.data.length === 0) {
    if (r.error) console.error('Could not update message:', r.error.message);
    return { error: SAVE_FAILED };
  }
  return { error: null };
}

export async function fetchSubscribers() {
  if (!supabase) return { subscribers: [], error: NOT_CONNECTED };
  var r = await supabase.from('newsletter_subscribers').select('*').order('created_at', { ascending: false });
  if (r.error) {
    console.error('Could not load subscribers:', r.error.message);
    return { subscribers: [], error: LOAD_FAILED };
  }
  return { subscribers: r.data || [], error: null };
}
